import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

export type ContactsHubTab = "contacts" | "calling" | "callLog";

export function ContactsSectionTabs({
  active,
  className,
  tabsListClassName,
  compact = false,
}: {
  active: ContactsHubTab;
  className?: string;
  tabsListClassName?: string;
  compact?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Tabs value={active} className={cn("w-full", className)}>
      <TabsList
        className={cn(
          "inline-flex w-full sm:w-auto",
          compact && "h-8",
          tabsListClassName,
        )}
      >
        <TabsTrigger
          value="contacts"
          asChild
          className={cn("whitespace-nowrap", compact && "px-2 text-xs")}
        >
          <Link to="/contacts">{t("sidebar.contacts")}</Link>
        </TabsTrigger>
        <TabsTrigger
          value="calling"
          asChild
          className={cn("whitespace-nowrap", compact && "px-2 text-xs")}
        >
          <Link to="/contacts/calling">{t("sidebar.hivogatas")}</Link>
        </TabsTrigger>
        <TabsTrigger
          value="callLog"
          asChild
          className={cn("whitespace-nowrap", compact && "px-2 text-xs")}
        >
          <Link to="/contacts/call-logs">{t("calling.callLogTab")}</Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
